import { defineSlotRecipe } from '@chakra-ui/react';
import colors from '../colors';
import fonts from '../fonts';

const Form = defineSlotRecipe({
  slots: ['helperText'],
  base: {
    helperText: {
      fontFamily: fonts.normal,
      fontSize: 13,
      px: '20px',
      py: '7px',
      color: 'podcastPurple800',
      bg: 'podcastShade100',
      border: `1px solid ${colors.podcastPurple200}`,
      borderRadius: '6px',
      minHeight: '36px',
      display: 'flex',
      alignItems: 'center',
    },
  },
});

export default Form;
